import { FullscreenExitOutlined } from '@ant-design/icons';
import React from 'react';

export const ErrorMessage: React.FC<{
  error: number | boolean;
  onClose: () => void;
}> = ({ onClose, error }) => {
  let text = 'Cannot load this asset';
  switch (error) {
    case 404:
      text = 'This asset does not exist';
      break;

    case 500:
      text = 'Internal server error';
      break;
  }

  return (
    <div className="al-fullscreen-preview__error">
      <h1>{text}</h1>
      <button onClick={onClose} className="al-fullscreen-preview__exit-fullscreen-button">
        <FullscreenExitOutlined /> Exit fullscreen preview
      </button>
    </div>
  );
};
